import { createAction } from 'redux-actions';

export const createRejectedToolkitAction = (baseName) =>
  createAction(`${baseName}/rejected`);

export const createFulfilledToolkitAction = (baseName) =>
  createAction(`${baseName}/fulfilled`);
